module.exports = __webpack_public_path__ + "static/media/hibiki-win.a855d569.png";